








































































import { Component } from 'vue-property-decorator';

import isMobile from '@/utils/mobile-check';

import { Surface, Picture, Typography } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import CoinNetworkFeatureTag from '@/componentsV2/atoms/CoinNetworkFeatureTag/CoinNetworkFeatureTag.vue';
import BillingService from '@/api/BillingService';
import BillingModel from '@/views/Models/BillingModel.vue';

@Component({
  components: {
    Surface,
    Picture,
    Typography,
    FilledButton,
    CoinNetworkFeatureTag
  }
})
export default class OfferEmptyStateCard extends BillingModel {
  billingService = new BillingService();

  get isMobileDevice() {
    return isMobile();
  }

  get content() {
    const appEmptyStateImage = {
      device: 'YOUR MEMBER APP VIEW',
      src: 'app-empty-state.png'
    };

    const widgetEmptyStateImage = {
      device: 'YOUR MEMBER WIDGET VIEW',
      src: 'widget-empty-state.png'
    };

    if (this.isWidgetAppActive && this.isMobileAppActive) {
      return {
        text:
          'Welcome Coins entice people to give your business a try because they act like real money. Instead of paying for costly ads, you’re now paying for results.',
        images: [appEmptyStateImage, widgetEmptyStateImage]
      };
    }

    if (this.isWidgetAppActive) {
      return {
        text:
          'Welcome Coins entice people to give your business a try because they act like real money. Instead of paying for costly ads, you’re now paying for results.',
        images: [widgetEmptyStateImage]
      };
    }

    return {
      text:
        'Welcome Coins entice people to give your business a try because they act like real money. Instead of paying for costly ads, you’re now paying for results.',
      images: [appEmptyStateImage]
    };
  }

  get isWidgetAppActive() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get ctaText() {
    if (this.inactiveBilling) return 'Upgrade & Set up Welcome Coins';
    return 'Start a Welcome Coins Campaign';
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get isMobileAppActive() {
    return (
      this.$store.getters['internationalization/getCountrySettings'].status ===
      'full'
    );
  }

  get title() {
    return 'Get new members with Welcome Coins';
  }

  async onClickCTA() {
    if (this.inactiveBilling) {
      this.onClickUpgrade({
        onSuccess: () => {
          this.gotoOfferCreation();
        },
        props: {
          welcomeCtaText: 'Explore Welcome Coins',
          origin: 'Empty State Welcome Coins'
        }
      });

      return;
    }
    this.gotoOfferCreation();
  }

  gotoOfferCreation() {
    this.$router.push('/marketing-center/offer-free-coins/create');
  }
}
